type TimelinePoint = {
  x: number;
  y: [number, number];
  label?: string;
  color?: string;
  toolTipContent?: string;
};

// Add presentation-only intervals; missing telemetry is not a measured state.
export function fillTimelineGaps(points: TimelinePoint[], start: number, end: number, color: string): TimelinePoint[] {
  if (end <= start) return points;
  const result = [...points];
  const rows = new Map<number, TimelinePoint[]>();
  for (const point of points) {
    if (!rows.has(point.x)) rows.set(point.x, []);
    rows.get(point.x)!.push(point);
  }
  for (const [x, row] of rows) {
    let cursor = start;
    const addGap = (from: number, to: number) => {
      if (to <= from) return;
      result.push({ x, y: [from, to], label: row[0].label, color,
        toolTipContent: 'Sem registros de telemetria neste intervalo',
      });
    };
    for (const point of [...row].sort((a, b) => a.y[0] - b.y[0])) {
      const from = Math.max(start, point.y[0]);
      const to = Math.min(end, point.y[1]);
      if (to <= from) continue;
      addGap(cursor, from);
      cursor = Math.max(cursor, to);
    }
    addGap(cursor, end);
  }
  return result;
}
